import {Pipe, PipeTransform} from '@angular/core';
import {DaysOnHoldType} from "@services";

@Pipe({
    name: 'daysOnHoldType',
    standalone: true
})
export class DaysOnHoldTypePipe implements PipeTransform {
    transform(value: DaysOnHoldType | string | undefined | null): string {
        if (!value) return '';

        switch (value) {
            case DaysOnHoldType.LessThan30Days: return "< 30 days";
            case DaysOnHoldType.LessThan45Days: return "< 45 days";
            case DaysOnHoldType.LessThan90Days: return "< 90 days";
            case DaysOnHoldType.MoreThan90Days: return "90+ days";
            default: return value;
        }
    }
}

